import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { IconByKey } from './IconByKey';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="recognize-title" data-id="element-261" data-mp="2w56pe9gs9bma">
      <div className="mx-auto max-w-5xl" data-id="element-262" data-mp="2r6daqdprfekj">
        <div id="recognize-title" data-id="element-263" data-mp="2r5ke45kim5g4">
          <SectionHeading title="Do you recognize yourself?" lead={<>
                If you answer <strong className="text-brand-700" data-id="element-265" data-mp="2i5x8t8oo0fhs">YES</strong> to any of these situations, I created this
                system for you.
              </>} data-id="element-264" data-mp="2m8k8twvhp6q2" />
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-266" data-mp="289ubcg4rd516">
          {recognizeItems.map(item => <li key={item.quote} className="flex gap-4 rounded-2xl bg-cream p-5 sm:flex-col sm:p-6" data-id="element-267" data-mp="bfqwn8y07cu0">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-700" data-id="element-268" data-mp="6hz2e89vzemn">
                <IconByKey icon={item.icon} className="h-5 w-5" data-id="element-269" data-mp="3jng8xzddrk9b" />
              </span>
              <div data-id="element-270" data-mp="3nkks63g0nkvm">
                <p className="font-serif text-lg font-bold leading-snug text-ink" data-id="element-271" data-mp="39mw8gyxoqjs5">{item.quote}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-272" data-mp="3elzeompeiw1p">{item.body}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-273" data-mp="67ibjte8bc1i">
          <p className="text-[17px] text-muted sm:text-lg" data-id="element-274" data-mp="b5s8a8flqkp8">You don’t necessarily need another course. You need to know:</p>
          <p className="mt-3 font-serif text-3xl font-bold italic text-brand-700 sm:text-4xl" data-id="element-275" data-mp="3skqp9z521zl3">What do I do now?</p>
          <p className="mt-3 text-[17px] text-muted sm:text-lg" data-id="element-276" data-mp="1dw9ev5oyqjy">
            And that is exactly what the Apometry Practice Deck™ was designed to solve.
          </p>
        </div>

        <SectionCta label="I want to stop improvising" data-id="element-277" data-mp="twtgln2m3slg" />
      </div>
    </section>;
}